import React from 'react';
import PropTypes from 'prop-types';

import styles from './styles.module.scss';

const PublicationTitle = ({ title }) => (
	// eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
	<h1 className={styles.EntityTitle} tabIndex={0}>
		{title}
	</h1>
);

PublicationTitle.propTypes = {
	title: PropTypes.string.isRequired
};

export default PublicationTitle;
